<template>
  <div class="cms-content-slice">
    <OpeningTimesModal v-if="openingTimesOpen && isMobile" :open="openingTimesOpen" :openingTimes="selectedDealerData.opening_times" @close-modal="openingTimesOpen = false"></OpeningTimesModal>
    <div class="cms-content-find-dealer__header-section">
      <h2 v-if="dealerSlice" class="cms-content-heading">{{ dealerSlice.heading_1 }}</h2>
    </div>

    <div class="cms-content-find-dealer">
      <figure ref="mapEl" class="cms-content-find-dealer__map"></figure>
      <div class="cms-content-find-dealer__location">
        <div v-if="loading" class="cms-content-find-dealer___dealer-group">
          <div class="cms-content-find-dealer__skeleton--image"></div>
          <div class="cms-content-find-dealer__dealer-group--content cms-content-find-dealer__skeleton--content">
            <div class="cms-content-find-dealer__skeleton--title"></div>
            <div class="cms-content-find-dealer__skeleton--line"></div>
            <div class="cms-content-find-dealer__skeleton--line short"></div>
            <div class="cms-content-find-dealer__skeleton--line"></div>
            <div class="cms-content-find-dealer__skeleton--line short"></div>
            <div class="cms-content-find-dealer__skeleton--button"></div>
          </div>
        </div>

        <div v-else-if="selectedGroup && selectedGroup.length" class="cms-content-find-dealer__dealer-group">

          <div class="cms-content-find-dealer__dealer-group--image-wrapper">
            <img
              class="cms-content-find-dealer__dealer-group--image"
              :src="imageUrl"
              :alt="groupName"
            />
          </div>

          <div class="cms-content-find-dealer__dealer-group--content">
            <h3 class="cms-content-find-dealer__dealer-group--name">{{ groupName }}</h3>

            <div class="cms-content-find-dealer__dealer-group--dealers">
              <div v-for="dealer in selectedGroup" :key="dealer.id" class="cms-content-find-dealer__dealer-group--dealer">
                <div class="cms-content-find-dealer__dealer-group--brand">{{ dealer.display_brand_name }}:</div>
                <div>
                  <a v-if="dealer.tel_general" class="cms-content-find-dealer__dealer-group--phone" :href="`tel:${dealer.tel_general}`">
                    {{ dealer.tel_general }}
                  </a>
                </div>
              </div>
            </div>

            <div class="cms-content-find-dealer__opening-times">
              <div
                class="cms-content-find-dealer__opening-times--summary"
                @click="openingTimesOpen = !openingTimesOpen"
              >
                <div class="cms-content-find-dealer__opening-times--opening-hours">
                  <span class="cms-content-find-dealer__opening-times--summary--heading">Opening hours:</span>
                  <span
                    class="cms-content-find-dealer__opening-times--summary"
                    :class="isOpenClass"
                    v-html="selectedDealerData.is_open"
                  ></span>
                </div>
                <div class="cms-content-find-dealer__opening-times--arrow" :class="{ 'is-open': openingTimesOpen }">
                  <svg class="caret-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 14 8">
                    <path fill="none" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" d="M1 1L7 7L13 1"/>
                  </svg>
                </div>
              </div>

              <div v-if="selectedDealerData && selectedDealerData.opening_times && !isMobile"
                class="cms-content-find-dealer__opening-times--details"
                :class="{ 'is-open': openingTimesOpen }"
                @click.stop
              >
                <div v-for="(schedule, type) in selectedDealerData.opening_times" :key="type" class="cms-content-find-dealer__opening-times--type">
                  <strong class="cms-content-find-dealer__opening-times--type--title">{{ capitalise(type) }}</strong>
                  <div class="cms-content-find-dealer__opening-times--list">
                    <template v-for="(hours, date) in schedule">
                      <div class="cms-content-find-dealer__opening-times--day">{{ date }}:</div>
                      <div class="cms-content-find-dealer__opening-times--time"><strong>{{ hours }}</strong></div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <p v-if="addressDealer" class="cms-content-find-dealer__dealer-group--address">
              {{ addressDealer.address }}, {{ addressDealer.town }}, {{ addressDealer.postcode }}
            </p>

            <div v-if="selectedDealerData" class="cms-content-find-dealer__dealer-group--btn-area">
              <a class="btn btn--secondary btn--full-width" :href="selectedDealerData.url">View details</a>
              <a v-if="selectedDealerData.offers_used" class="btn btn--primary btn--full-width" :href="selectedDealerData.used_url">
                View {{ usedStockCount }} used vehicles
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { calculateDistance } from '../../../../js/used-vue/api/LocationFunctions'
import OpeningTimesModal from './Components/OpeningTimesModal.vue';

export default {
  props: { dealerSlice: Object },
  components:{
    OpeningTimesModal
  },
  data() {
    return {
      map: null,
      googleClass: null,
      dealers: [],
      groupedDealers: {},
      dealerMarkers: {},
      activeMarkerId: null,
      hasUserLocation: false,

      selectedGroup: null,
      selectedDealerData: null,
      loading: false,
      openingTimesOpen: false,
      dealerBounds: null,
      userLat: null,
      userLng: null,
      mapZoom: 10,

      windowWidth: window.innerWidth
    }
  },

  computed: {
    groupName() {
      return this.selectedGroup?.[0]?.dealer_group_name || ''
    },

    imageUrl() {
      return this.selectedDealerData ? `${this.selectedDealerData.img_url}` : '/images/dealers/image-coming-soon.svg'
    },

    addressDealer() {
      return this.selectedGroup?.find(d => d.address || d.town || d.postcode)
    },

    usedStockCount() {
      return this.selectedDealerData?.used_stock_count ?? 0
    },

    isOpenClass() {
      const open = this.selectedDealerData?.is_open || ''
      return open.includes('Open')
        ? 'cms-content-find-dealer__opening-times--summary--open'
        : 'cms-content-find-dealer__opening-times--summary--closed'
    },
    isMobile() { return this.windowWidth <= 768 }
  },

  mounted() {
    this.initMap()
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize() { this.windowWidth = window.innerWidth },

    capitalise(str) { return str.charAt(0).toUpperCase() + str.slice(1) },

    async initMap() {
      this.googleClass = await GoogleMapsLoader.getMap()

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            this.hasUserLocation = true
            this.userLat = position.coords.latitude
            this.userLng = position.coords.longitude
            await this.initMapWithCoords()
          },
          async () => {
            this.hasUserLocation = false
            await this.initMapWithCoords()
          }
        )
      } else {
        await this.initMapWithCoords()
      }
    },

    async initMapWithCoords() {
      this.map = new this.googleClass.maps.Map(this.$refs.mapEl, {
        zoom: this.mapZoom,
        center: {
          lat: this.userLat,
          lng: this.userLng,
        },
        mapTypeControl: false,
        scrollwheel: false,
        draggable: false,
      })

      const locationData = await window.LocationDataLoader.get(true, true, true)
      this.dealers = locationData
      this.groupedDealers = this.groupDealers(locationData)

      await this.setupDealerMarkers()

      this.googleClass.maps.event.addListener(this.map, 'click', () => {
        this.map.setOptions({ scrollwheel: true, draggable: true })
      })
    },

    groupDealers(dealers) {
      return dealers.reduce((groups, dealer) => {
        if (!dealer.dealer_group_name) return groups

        const key = dealer.dealer_group_name
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '-')

        if (!groups[key]) groups[key] = []
        groups[key].push(dealer)
        return groups
      }, {})
    },


    async setupDealerMarkers() {
      const defaultIcon = await this.getMapIcon(false)
      const selectedIcon = await this.getMapIcon(true)

      this.dealerBounds = new this.googleClass.maps.LatLngBounds()

      for (const key in this.groupedDealers) {
        const dealers = this.groupedDealers[key]
        const firstDealer = dealers[0]

        if (!firstDealer?.lat || !firstDealer?.lng) continue

        const lat = parseFloat(firstDealer.lat)
        const lng = parseFloat(firstDealer.lng)

        const position = { lat, lng }

        const marker = new this.googleClass.maps.Marker({
          map: this.map,
          position,
          icon: defaultIcon
        })

        this.dealerBounds.extend(position)

        this.dealerMarkers[firstDealer.id] = marker

        marker.addListener('click', () => {
          for (const id in this.dealerMarkers) {
            if (this.dealerMarkers[id] !== marker) {
              this.dealerMarkers[id].setIcon(defaultIcon)
            }
          }

          this.selectDealerGroup(dealers, firstDealer.id)
          marker.setIcon(selectedIcon)
        })
      }

      if (!this.dealerBounds.isEmpty()) {
        this.map.fitBounds(this.dealerBounds)

        this.googleClass.maps.event.addListenerOnce(this.map, 'idle', () => {
          this.selectClosestDealer()
        })
      }
    },

    async selectDealerGroup(dealers, dealerId) {
      this.loading = true
      this.selectedGroup = dealers
      this.openingTimesOpen = false

      try {
        const res = await fetch(`/api/dealer-map-location-data?locationId=${dealerId}`)
        this.selectedDealerData = await res.json()
      } catch (err) {
        console.error('Failed to fetch dealer data:', err)
        this.selectedDealerData = null
      } finally {
        this.loading = false
      }
    },

    async getMapIcon(selected) {
      const Size = this.googleClass.maps.Size
      const Point = this.googleClass.maps.Point

      return {
        url: selected
          ? '/images/redesign/map/map-pin-selected.svg'
          : '/images/redesign/map/map-pin.svg',
        scaledSize: new Size(28, 34),
        anchor: new Point(14, 34),
      }
    },

    async selectClosestDealer() {
      if (!this.dealers.length) return

      const center = this.hasUserLocation
        ? { lat: this.userLat, lng: this.userLng }
        : this.dealerBounds.getCenter()
      const closest = this.dealers.reduce((closest, dealer) => {
        const dist = calculateDistance(
          center.lat,
          center.lng,
          Number(dealer.lat),
          Number(dealer.lng)
        )

        if (!closest || dist < closest.distance) {
          return { dealer, distance: dist }
        }
        return closest
      }, null)?.dealer

      if (!closest) return

      const key = closest.dealer_group_name
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')

      this.dealerMarkers[closest.id]?.setIcon( await this.getMapIcon(true))
      this.activeMarkerId = closest.id
      this.selectDealerGroup(this.groupedDealers[key], closest.id)
    },

    capitalise(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  }
}
</script>